import * as React from 'react';

import { GenericError, IGenericErrorProps } from '@opendoor/cinderblocks/platform/GenericError';

import Layout from '../components/Layout';

class ErrorPage extends React.PureComponent<IGenericErrorProps> {
  public render() {
    return <Layout renderContent={this.renderContent} />;
  }

  public renderContent = () => <GenericError {...this.props} />;
}

export default ErrorPage;
